import Vue from 'vue';
import batchLogTransformer from '../../transformers/batchLog';
import items from './items';

const success = (resolve, batchId, page, limit) => {
  resolve();
  items({
    page,
    limit,
    batch_id: batchId,
  });
};

const failed = (errors, reject) => {
  reject(batchLogTransformer.fetch(errors));
};

export default (batch, page, limit) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/batch_log', batch)
      .then(() => {
        success(resolve, batch.batch_id, page, limit);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchLog/store.js